import Question from "models/question";
import { QuestionnaireComponentTranslations } from "translations/types";

export function extractHpvFlowError(
    question: Question,
    translations: { questionnaireComponent: QuestionnaireComponentTranslations }
): string | undefined {
    if (question.validateHpvFlow && question.answer?.rawValue === "male") {
        return translations.questionnaireComponent.invalidHpvFlowGender;
    }

    return undefined;
}
